<template>
    <div class="blocked-ip-container">
        <div class="blocked-ip-title">{{ $t("blockedIp.title") }}</div>
        <div class="blocked-ip-description">{{ $t("blockedIp.description") }}</div>
        <div class="blocked-ip-suggestion">{{ $t("blockedIp.suggestion", { ip: user.lastLoginIPAddress }) }}</div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "BlockedIP",
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
};
</script>
<style lang="scss" scoped>
.blocked-ip-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 10px;
}
.blocked-ip-title {
    font-size: 24px;
    font-weight: 600;
}
.blocked-ip-description {
    font-size: 16px;
}
.blocked-ip-suggestion {
    font-size: 16px;
}
</style>
